import axios from 'axios';

/**
 * Client for the order API endpoints
 */
class OrderClient {
  constructor(backendUrl) {
    this.backendUrl = backendUrl;
  }

  /**
   * Standard headers required for every order request
   */
  getHeaders() {
    return {
      'X-User-Id': localStorage.getItem('userId')
    };
  }

  /**
   * Mark an order as paid or unpaid
   */
  async setOrderPayment(orderId, paid) {
    return axios.put(`${this.backendUrl}/orders/${orderId}/payment`, { paid }, {
      headers: this.getHeaders()
    });
  }

  /**
   * Accept a pending order
   */
  async acceptOrder(orderId) {
    return axios.put(`${this.backendUrl}/orders/${orderId}/accept`, null, {
      headers: this.getHeaders()
    });
  }

  /**
   * Set the ETA on an order
   */
  async setOrderEta(orderId, eta) {
    return axios.put(`${this.backendUrl}/orders/${orderId}/set_eta`, { eta }, {
      headers: this.getHeaders()
    });
  }

  /**
   * Reject an order with a reason
   */
  async rejectOrder(orderId, reason) {
    return axios.put(`${this.backendUrl}/orders/${orderId}/reject`, { reason }, {
      headers: this.getHeaders()
    });
  }
}

export default OrderClient;
